export function checkNeedToLineLogin() {
  const ignoreToLineLoginPathList = [
    '/question-and-answer',
    '/privacy-policy',
    '/line-account-partner',
  ]
  const pathname = decodeURIComponent(window.location.pathname)  
  return !ignoreToLineLoginPathList.includes(pathname)
}
